/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
export { Core__factory } from "./Core__factory";
